import { ResourceProps } from "react-admin";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";

const promotionsPages: ResourceProps = {
  name: Resource.PROMOTIONS_PAGE,
  icon: LocalOfferOutlinedIcon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Promotions",
  },
};

export default promotionsPages;
